import axios from 'axios'
import store from '../../vuex/store'
import {getServerApi} from '../../config/deployment'

let envUri = getServerApi()
let pricingUri = envUri+'/api/rules/pricing/ee'

let dummyRules = {
  'min_weekly_discount_days':7,
  'max_short_rent_period_in_days':30,
  'max_base_rent_period_in_days':91,
  'max_medium_rent_period_in_days':183,
  'max_long_rent_period_in_days':-1,
  'daily_rate_applied':['max_short_rent_period_in_days'],
  'montlhy_rate_applied':['max_base_rent_period_in_days', 'max_medium_rent_period_in_days', 'max_long_rent_period_in_days'],
  'max_days_when_cleaning_fee':31,
  'max_days_when_essentials_fee':31,
  'owner_fees':['cleaning','essentials','rent','utility'],
  'moowle_fees':['booking'],
  'max_moowle_rent_fee':190.00,
  'moowle_rent_fee_percentage': 10
}

export const getPricingRules = () => {
  return new Promise((resolve, reject) => {
    if(Object.keys(store.getters.pricingRules).length === 0 && store.getters.pricingRules.constructor === Object ) {
      axios.get(pricingUri)
        .then(resp => {
          if(resp.data.body) {
            store.commit("SET_PRICING_RULES", resp.data.body)
            resolve(resp.data.body)
          }
          else reject()
        })
        .catch(error => {
           reject()
        })
    }else{
      resolve(store.getters.pricingRules)
    }
  })
}



// WEBPACK FOOTER //
// ./src/pricing/repository/pricingRepository.js